"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkProjectMember = exports.isProjectMember = void 0;
const __1 = require("..");
function isProjectMember(object) {
    return checkProjectMember(object).fulfilled;
}
exports.isProjectMember = isProjectMember;
function checkProjectMember(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasChoice)("status", ["active", "archived", "inactive"]), (0, __1.hasString)("name"), (0, __1.hasNumber)("lastOpenedChatTimestamp"), (0, __1.hasBoolean)("hasUnreadMessages"), (0, __1.hasChoice)("externalMemberRole", ["EXTERNAL", "EXTERNAL_SUPERVISOR"]).optional()).withOptions(options).explain();
}
exports.checkProjectMember = checkProjectMember;
//# sourceMappingURL=ProjectMember.js.map